import {TFunction} from '@wix/yoshi-flow-editor';
import {SubscriptionFrequency, SubscriptionSettingsModel} from '../models/LineItems/SubscriptionSettings.model';

export const getLineItemSubscriptionFrequencyText = (t: TFunction, subscription: SubscriptionSettingsModel): string => {
  if (subscription.interval > 2) {
    switch (subscription.frequency) {
      case SubscriptionFrequency.DAY: {
        return t('cart.page_plan_frequency_description_days_plural_label', {
          numberOfFrequencyUnits: subscription.interval,
        });
      }
      case SubscriptionFrequency.WEEK: {
        return t('cart.page_plan_frequency_description_weeks_plural_label', {
          numberOfFrequencyUnits: subscription.interval,
        });
      }
      case SubscriptionFrequency.MONTH: {
        return t('cart.page_plan_frequency_description_months_plural_label', {
          numberOfFrequencyUnits: subscription.interval,
        });
      }
      case SubscriptionFrequency.YEAR: {
        return t('cart.page_plan_frequency_description_years_plural_label', {
          numberOfFrequencyUnits: subscription.interval,
        });
      }
    }
  }
  switch (subscription.frequency) {
    case SubscriptionFrequency.DAY: {
      return subscription.interval === 2
        ? t('cart.page_plan_frequency_description_2_days_label')
        : t('cart.page_plan_frequency_description_day_singular_label');
    }
    case SubscriptionFrequency.WEEK: {
      return subscription.interval === 2
        ? t('cart.page_plan_frequency_description_2_weeks_label')
        : t('cart.page_plan_frequency_description_week_singular_label');
    }
    case SubscriptionFrequency.MONTH: {
      return subscription.interval === 2
        ? t('cart.page_plan_frequency_description_2_months_label')
        : t('cart.page_plan_frequency_description_month_singular_label');
    }
    case SubscriptionFrequency.YEAR: {
      return subscription.interval === 2
        ? t('cart.page_plan_frequency_description_2_years_label')
        : t('cart.page_plan_frequency_description_year_singular_label');
    }
  }
  return '';
};
